import { fireRegisterGAEvent } from '@global/gtm/base';

export function fireRegisterEvent() {
  window.dataLayer = window.dataLayer || [];

  fireRegisterGAEvent({
    actionType: '申請會員',
    registerType: 'EMAIL',
  });
}

export function fireRegisterGTMEventByLINE() {
  window.dataLayer = window.dataLayer || [];

  fireRegisterGAEvent({
    actionType: '申請會員',
    registerType: 'LINE',
  });
}

export function fireRegisterGTMEventByFB() {
  window.dataLayer = window.dataLayer || [];

  fireRegisterGAEvent({
    actionType: '申請會員',
    registerType: 'facebook',
  });
}
